import React from 'react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router';

import {Modal, ModalHeader, showModal} from '@edna/components';
import {Icon, Stack} from '@edna/components/primitives';

import {Text} from 'src/components/primitives';
import {channelIconHash} from 'src/constants';
import {useGetAllSubjectsQuery} from 'src/containers/Subjects/api';

const LinkedSubjectsModal = React.memo<{closeModal: TEmptyFunction; linkedSubjects: number[]}>(
  ({linkedSubjects}) => {
    const {t} = useTranslation();
    const {id: tenantId} = useParams();

    const {subjects = []} = useGetAllSubjectsQuery(
      {tenantId},
      {
        selectFromResult: ({data}) => ({
          subjects: data?.filter((subject) => linkedSubjects.includes(subject.id)),
        }),
      },
    );

    return (
      <Modal width="430px">
        <ModalHeader>{t('Tariffs:linkedSubjectsModal.title')}</ModalHeader>
        <Stack size="2">
          {subjects.map((subject) => (
            <Stack size="2" key={subject.id} direction="ROW" align="center">
              <Icon size="20px" as={channelIconHash[subject.type]} />
              <Text size="S">{subject.name}</Text>
            </Stack>
          ))}
        </Stack>
      </Modal>
    );
  },
);

LinkedSubjectsModal.displayName = 'LinkedSubjectsModal';

export const showLinkedSubjectsModal = (subjects: number[]) =>
  showModal((closeModal) => (
    <LinkedSubjectsModal closeModal={closeModal} linkedSubjects={subjects} />
  ));
